module.exports = __webpack_public_path__ + "vn.svg?be36edc23db257236d8d17040b365ffc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/vn.svg
// module id = 1416
// module chunks = 27